<template>
    <div>
        <post-related-items :post-id="post.id" :post-template-ids="[19]">
            <template v-slot:success="s">
                <div class="author_container">
                    <div class="author_item" v-for="post in s.posts.data" :key="post.id">
                        <img :data-src="post.values.emp_image" v-img-lazy.nodefault />
                        <span class="author_name">{{post.name}}</span>
                        <span class="author_mail"><a :href="'mailto:'+post.values.emp_email">Send e-post</a></span>
                    </div>
                </div>
            </template>
        </post-related-items>
        
        <div class="post_content">
            <header class="single-article-header floatnone textcenter marginauto">
                <i class="fal fa-calendar"></i>
                <span class="news-date"> {{post.createdWhen | date('DD MMM YYYY')}}</span>
                <h1>
                    {{post.values.title}}
                </h1>
                <div class="single-article-excerpt">
                    {{post.values.default_ingress}}
                    <hr />
                </div>
            </header>

            <div class="single-article-text floatnone marginauto clearfix">
                <div class="single-article-img clearfix">
                    <img :src="post.values.default_featuredimage" :alt="post.values.default_headline" class="single-article-img" />
                    <span class="single-article-imgtext">
                        <!-- TODO. where is this? -->
                        <!-- {content:featuredimage_text} -->
                    </span>
                </div>
                <div v-html="post.values.default_maintext"></div>
            </div>

            <footer class="marginauto floatnone">
                <div class="xt-social-sharing">
                    <div class="addthis_sharing_toolbox"></div>
                </div>
            </footer>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import PostRelatedItems from '@/components/post-related-items/PostRelatedItems.vue';

export default Vue.extend({
	props: {
		post: {
			type: Object,
			required: true,
		},
	},
	components: {
		PostRelatedItems,
	},
});
</script>